import { Contract } from "./Contract";
import { Customer } from "./Customer";
import { LocationType } from "./Enums";
import { Location } from "./Location";

export class Schedule {
    scheduleId: number = 0;
    scheduleIdDisplay: string = '';
    locCode: string = '';
    scheduleBeginDate: string = '';
    scheduleEndDate: string = '';
    beginDate: string = '';
    endDate: string = '';
    createdBy: string = '';
    locationType: LocationType = LocationType.Origin;
    scheduleType: string = '';
    customer: Customer = new Customer();
    location: Location = new Location();

    commodityCode: string = '';
    alternateCommodity: string = '';
    commodityUnitOfMeasure: string = '';
    loadNumber: string = '';
    loadNotes: string = '';
    locationNotes: string = '';
    internalNotes: string = '';
    loads: number = 0;

    defaultAccountId: number = 0;
    dispatchedLoads: number = 0;
    balanceLoads: number = 0;
    unassignedLoads: number = 0;
    confirmedLoads: number = 0;
    unconfirmedLoads: number = 0;

    contracts: Contract[] = [];
}
